window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('./../../../node_modules/luminous-lightbox/dist/luminous.js');
window.Macy = require('macy');
window.moment = require('moment');
window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

require('./main/marquee');
require('./main/theia-sticky-sidebar');
require('./main/jquery.jplayer.min');
require('./main/jplayer.playlist.min');
require('./main/slick.min');
require('./main/carouFredSel');
require('./main/jquery.magnific-popup');
require('./main/jquery.easy-ticker.min');
require('./main/main');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js